import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import Sticky from 'react-stickynode';
import { isMobileOnly } from "react-device-detect";
import AppBar from './AppBar';
import NavBar from './NavBar';
import AppBarNoAccess from './AppBarNoAccess'
import AppBarOther from './AppBarOther'
import i18n from './i18n';
class App extends PureComponent {

  constructor(props) {
    super(props);

    let isFP = false;
    if (window.isFP) {
      isFP = window.isFP;
    }

    let isoCode = 'en-GB';
    if (window.dpdplat.isoCode) {
      isoCode = window.dpdplat.isoCode;
    }

    let isLoggedIn = false;
    if (window.portfolioMapper && (window.portfolioMapper.token && window.portfolioMapper.token !== '')) {
      isLoggedIn = true;
    }

    let toolsToShow = [
      'portfolio-analysis',
      'performance-at-a-glance',
    ];
    if (window.dpdplat && window.dpdplat.toolsToShow) {
      toolsToShow = window.dpdplat.toolsToShow;
    }

    let resourcesToShow = ['dashboard',
      'dailyperf',
      'shortlevsim',
      'shortlevfaq',
      'ecocal'
    ];
    if (window.dpdplat && window.dpdplat.resourcesToShow) {
      resourcesToShow = window.dpdplat.resourcesToShow;
    }

    this.state = {
      isFP: isFP,
      isLoggedIn: isLoggedIn,
      toolsToShow: toolsToShow,
      resourcesToShow: resourcesToShow,
      activeApp: '',
      isoCode: isoCode
    };

    this.handleLoad = this.handleLoad.bind(this);
    i18n.changeLanguage(isoCode);
  }

  componentDidMount() {
    let {
      history,
    } = this.props;

    window.addEventListener('load', this.handleLoad);

    history.listen(() => {
      const hash = history.location.hash.substring(1).split('&')[0];
      this.activateApp(hash);
    });

    const e = {
      "eventAction": "App Open",
      "eventLabel": "Home Page",
      "type": "CustomTagEvent"
    };

    if (window.digitalData) {
      if (e.eventLabel != '') {
        window.digitalData.newEvent(e);
        console.log('Window digitalData: ', e);
      }
    } else {
      console.log('no Window digitalData : ', e);
    }

  }

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad)
  }

  handleLoad() {
    const hash = window.location.hash.substring(1).split('&')[0];
    if (hash !== '' && hash !== 'toolscenter') {
      this.activateApp(hash);
    }
  }

  selectApp = (appName) => {
    let {
      activeApp,
    } = this.state;

    let newApp = (activeApp === appName) ? '' : appName;
    window.location = '#' + newApp + '&';
  }

  convertAppName = (name) => {
    switch (name) {
      case 'dpd':
        return 'portfolio-analysis'
      case 'topperf':
        return 'performance-at-a-glance'
      default:
        return name;
    }
  }

  activateApp = (activeApp) => {
    const {
      isFP,
      toolsToShow,
    } = this.state;

    // convert the app name to current naming
    activeApp = this.convertAppName(activeApp);

    // filter out non FP if trying to get to FP app
    const gpApps = ['', 'performance-at-a-glance', 'dailyperf', 'ecocal', 'shortlevfaq', 'shortlevsim']
    if (toolsToShow.includes(activeApp) && !isFP && !gpApps.includes(activeApp)) {
      window.location.href = '/restricted-material';
    }

    // scroll to toolscenter and activate appropriate app
    let nav = document.getElementById('toolscenter');
    if (nav) {
      nav.scrollIntoView({ top: 0, behavior: 'smooth' });
    }

    if ((activeApp === '' || toolsToShow.includes(activeApp)) && activeApp !== 'toolscenter') {
      this.updateActiveApp(activeApp);
    }

    const e = {
      "eventName": "Nav",
      "eventLabel": activeApp,
      "type": "CustomTagEvent"
    };

    if (window.digitalData) {
      if (e.eventLabel != '') {
        window.digitalData.newEvent(e);
        console.log('Window digitalData: ', e);
      }
    } else {
      console.log('no Window digitalData : ', e);
    }


  };

  updateActiveApp = (activeApp) => {
    this.setState({
      activeApp: activeApp,
    });
  }

  render() {
    const {
      isFP,
      isLoggedIn,
      toolsToShow,
      resourcesToShow,
      activeApp,
    } = this.state;

    const onDashboard = window.location.href.indexOf('dashboard') > -1 ? true : false;

    return (
      <div>
        <div className='row' style={{ backgroundColor: '#FFF' }}>
          <div id='toolscenter' />
          <Sticky innerZ={100} enabled={!isMobileOnly} top={0}>
            <NavBar
              isFP={isFP}
              activeApp={activeApp}
              selectCallback={this.selectApp}
              toolsToShow={toolsToShow}
            />
          </Sticky>
          {/* {isLoggedIn && isFP && toolsToShow.includes('portfolio-analysis') &&
            <AppBar title='Portfolio Analysis'
              description='Analyze portfolios, stress test against a variety of market scenarios, and identify opportunities to improve outcomes.'
              name='portfolio-analysis'
              divId='dpd'
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          }

          {toolsToShow.includes('performance-at-a-glance') &&
            <AppBar title='Performance at a Glance'
              description='Compare our best and worst performing unleveraged Exchange Traded Products (ETPs) across various time ranges.'
              name='performance-at-a-glance'
              divId='topperf'
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          } */}
          <div className="clearfix" />
        </div>
        {/* <React.Fragment>
          <div className='row' style={{ backgroundColor: '#FFF' }}>
            {!isLoggedIn && activeApp === '' && toolsToShow.includes('portfolio-analysis') &&
              <AppBarNoAccess title='Portfolio Analysis'
                description='Analyze portfolios, stress test against a variety of market scenarios, and identify opportunities to improve outcomes.'
                name='portfolio-analysis'
                divId='dpd'
                activeApp={activeApp}
                link='https://www.wisdomtree.com/wisdomtree-tools#portfolio-analysis&'
                message='Financial Professional Access Only'
              />
            }
          </div>
        </React.Fragment> */}
        {/* {activeApp === '' && resourcesToShow.length > 0 &&
          <div className='row' style={{ backgroundColor: '#FFF' }}>
            <div className='col-sm-12' style={{ fontSize: '28px', fontWeight: '300', marginTop: '60px' }}>INVESTOR RESOURCES</div>
          </div>
        } */}
        <div className='row' style={{ backgroundColor: '#FFF' }}>

          {!isLoggedIn && activeApp === '' && resourcesToShow.includes('performance-at-a-glance') &&
            <AppBarOther
              title={i18n.t('TitleBestWorstPerf')}
              description={i18n.t('DescribeBestWorstPerf')}
              name='performance-at-a-glance'
              activeApp={activeApp}
              link='https://sitecoredev.wisdomtree.eu/en-gb/resource-library/test%20top%20performance '
            />
          }
          {!isLoggedIn && activeApp === '' && resourcesToShow.includes('portfolio-analysis') &&
            <AppBarOther
              title={i18n.t('TitleDPD')}
              description={i18n.t('DescribeDPD')}
              name='portfolio-analysis'
              activeApp={activeApp}
              link='https://www.wisdomtree.eu/en-gb/investor-solutions/digital-portfolio-developer '
            />
          }

          {!isLoggedIn && activeApp === '' && resourcesToShow.includes('dailyperf') &&
            <AppBarOther
              title={i18n.t('TitleDailyPerf')}
              description={i18n.t('DescribeDailyPerf')}
              name='dailyperf'
              activeApp={activeApp}
              link='https://sitecoreprod.wisdomtree.eu/en-gb/product-performance'
            />
          }
          {!isLoggedIn && activeApp === '' && resourcesToShow.includes('ecocal') &&
            <AppBarOther
              title={i18n.t('TitleEcoCal')}
              description={i18n.t('DescribeEcoCal')}
              name='ecocal'
              activeApp={activeApp}
              link='https://www.wisdomtree.eu/en-gb/resource-library/short-and-leveraged-centre/economic-calendar'
            />
          }
          {!isLoggedIn && activeApp === '' && resourcesToShow.includes('shortlevfaq') &&
            <AppBarOther
              title={i18n.t('TitleShortLevFAQ')}
              description={i18n.t('DescribeShortLevFAQ')}
              name='shortlevfaq'
              activeApp={activeApp}
              link='https://www.wisdomtree.eu/en-gb/resource-library/short-and-leveraged-centre/smart-faq'
            />
          }
          {!isLoggedIn && activeApp === '' && resourcesToShow.includes('shortlevsim') &&
            <AppBarOther
              title={i18n.t('TitleShortLevSim')}
              description={i18n.t('DescribeShortLevSim')}
              name='shortlevsim'
              activeApp={activeApp}
              link='https://www.wisdomtree.eu/en-gb/resource-library/short-and-leveraged-centre/short-and-leveraged-simulator'
            />
          }
        </div>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js